import { render } from "./etmfPieChart2.vue?vue&type=template&id=5191ecf2&scoped=true"
import script from "./etmfPieChart2.vue?vue&type=script&lang=js"
export * from "./etmfPieChart2.vue?vue&type=script&lang=js"

import "./etmfPieChart2.vue?vue&type=style&index=0&id=5191ecf2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5191ecf2"]])

export default __exports__